export enum TypeNewsEnum {
  WITH_AUTHORIZATION = 'Com autorização',
  WITHOUT_AUTHORIZATION = 'Sem autorização',
  RELEASED = 'Publicadas',
  SCHEDULED = 'Programadas',
}
